"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getRunRate_1 = __importDefault(require("./getRunRate"));
const getBallsRemaining_1 = __importDefault(require("./getBallsRemaining"));
const getProjectedTotal = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    const runRate = props.runRate ||
        getRunRate_1.default({
            oversBowled: props.oversBowled,
            runs: props.runs,
            ballsPerOver: props.ballsPerOver,
        });
    const ballsRem = getBallsRemaining_1.default({
        ballsPerOver: props.ballsPerOver,
        oversBowled: props.oversBowled,
        oversPerInnings: props.oversPerInnings,
        oversTarget: props.oversTarget,
    });
    return props.runs + lodash_1.round(runRate * (ballsRem / props.ballsPerOver), 0);
};
exports.default = getProjectedTotal;
//# sourceMappingURL=getProjectedTotal.js.map